
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './loading-dots.css';
import InchidereContCard from './InchidereContCard';

import './Settings.css';

import { useDarkMode } from '../DarkModeContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faChevronLeft, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';

import ProfilCard from './ProfilCard';

import PreferinteCard from './PreferinteCard';

import ResetareProgres from './ResetareProgres/ResetareProgres';

import DetaliiPlanCard from './DetaliiPlanCard';


import PWASettingsCard from './PWASettingsCard';
import AvatarEditor from '../content/functionalpagelogin/leftSidebar/pages/profile/avatar/AvatarEditor';
import { defaultAvatar } from '../content/functionalpagelogin/leftSidebar/pages/profile/avatar/avatarConfig';

import { redirectToLogin } from '../utils/authRedirect';
import { clearCourseStorage } from '../utils/courseAccess';

import '../content/functionalpagelogin/leftSidebar/pages/reglaredimensiune.css';

const apiUrl = process.env.REACT_APP_API_URL;

// Un singur set de optiuni pentru desktop si mobil.

const GROUPS = [

 {
  title: 'Cont',
  tabs: [
    { key: 'profil', label: 'Editare profil' },
    { key: 'preferinte', label: 'Preferinte' },
    
    { key: 'aplicatie', label: 'Aplicație' },
    { key: 'resetare-progres', label: 'Resetare progres' },
    { key: 'confidentialitate', label: 'Confidentialitate' },
  ],
},

  {

	title: 'Abonament',

	tabs: [{ key: 'plan', label: 'Planul tau' }],

  },

  {

	title: 'Asistenta',

	tabs: [

	  { key: 'feedback', label: 'Feedback' },

	  { key: 'intrebari', label: 'Intrebari' },

	],

  },

];

const FALLBACK_USER = {

  username: 'Vizitator',

  email: '',

  profile_picture: '',

  account_type: 'free',

  is_active: false,

};

const NoticeCard = ({ title, children }) => (

  <div className="tabMenuCard">

	<h3 className="tabMenuTitle">{title}</h3>

	<div style={{ padding: 16 }}>{children}</div>

  </div>

);

const Settings = ({

  activeTab,

  setActiveTab,

  onBackToProfile,

  onAvatarEditorChange

}) => {

  const { setUser: setAuthUser } = useAuth();
  const navigate = useNavigate();
  const [deletingAccount, setDeletingAccount] = useState(false);
  const [deleteError, setDeleteError] = useState('');

  const [userData, setUserData] = useState(null);

  const [loading, setLoading] = useState(true);

  const [selectedFile, setSelectedFile] = useState(null);

  const [previewImage, setPreviewImage] = useState(null);

  const [successMessage, setSuccessMessage] = useState('');
  const [messageType, setMessageType] = useState('success');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const [username, setUsername] = useState('');
  const [nickname, setNickname] = useState('');

  const [soundEffects, setSoundEffects] = useState(true);


const [showCardMobile, setShowCardMobile] = useState(false);

const [showAvatarEditor, setShowAvatarEditor] = useState(false);

  const [isSavingAvatar, setIsSavingAvatar] = useState(false);

  const [windowWidth, setWindowWidth] = useState(

	typeof window !== 'undefined' ? window.innerWidth : 1200

  );

  const { darkMode, setDarkMode } = useDarkMode();

  const isMobile = windowWidth <= 1100;

  const activeLabel = GROUPS.flatMap(group => group.tabs)

	.find(tab => tab.key === activeTab)?.label || 'Setari';

  useEffect(() => {

	const handleResize = () => setWindowWidth(window.innerWidth);

	window.addEventListener('resize', handleResize);

	return () => window.removeEventListener('resize', handleResize);

  }, []);

  useEffect(() => {

	let cancelled = false;

	const fetchUserData = async () => {

	  try {

		const response = await fetch(`${apiUrl}/user`, {

		  method: 'GET',

		  credentials: 'include',

		});

		if (!response.ok) throw new Error('Nu s-au putut incarca datele.');

		const data = await response.json();

		if (cancelled) return;

		setUserData(data);

		setUsername(data.username || '');
		setNickname(data.nickname || '');

		if (typeof data.dark_mode === 'boolean') {

		  setDarkMode(data.dark_mode);

		}

		if (typeof data.sound_effects === 'boolean') {

		  setSoundEffects(data.sound_effects);

		}

	  } catch (error) {

		console.error('Eroare la incarcarea profilului:', error);

		if (!cancelled) setUserData(FALLBACK_USER);

	  } finally {

		if (!cancelled) setLoading(false);

	  }

	};

	fetchUserData();

	return () => { cancelled = true; };

	// setDarkMode este furnizat de context.

  }, [setDarkMode]);

  const showMessage = (message, type = 'success') => {

	setMessageType(type);

	setSuccessMessage(message);

  };

  const handleFileChange = event => {

	const file = event.target.files?.[0];

	if (!file) return;

	setSelectedFile(file);

	const reader = new FileReader();

	reader.onloadend = () => setPreviewImage(reader.result);

	reader.readAsDataURL(file);

  };

  const uploadProfilePicture = async () => {

	if (!previewImage) return;

	try {

	  const response = await fetch(`${apiUrl}/user/update-profile-picture`, {

		method: 'POST',

		headers: { 'Content-Type': 'application/json' },

		credentials: 'include',

		body: JSON.stringify({ profile_picture: previewImage }),

	  });

	  const result = await response.json();

	  if (!response.ok) {

		throw new Error(result.message || 'Eroare la actualizarea imaginii.');

	  }

	  setUserData(prev => ({

		...prev,

		profile_picture: result.profile_picture,

	  }));

	  setPreviewImage(null);

	  setSelectedFile(null);

	  showMessage('Imaginea a fost actualizata cu succes.');

	} catch (error) {

	  console.error(error);

	  showMessage(error.message || 'Eroare la incarcarea imaginii.', 'error');

	}

  };

  const onProfilePictureDelete = async () => {

	if (!window.confirm('Esti sigur ca doresti sa stergi imaginea de profil?')) {

	  return;

	}

	try {

	  const response = await fetch(`${apiUrl}/user/delete-profile-picture`, {

		method: 'DELETE',

		credentials: 'include',

	  });

	  if (!response.ok) throw new Error('Imaginea nu a putut fi stearsa.');

	  setUserData(prev => ({ ...prev, profile_picture: '' }));

	  setPreviewImage(null);

	  setSelectedFile(null);

	  showMessage('Imaginea de profil a fost stearsa.');

	} catch (error) {

	  console.error(error);

	  showMessage(error.message, 'error');

	}

  };

const onProfileSave = async event => {
  event.preventDefault();

  // Parola se schimba doar daca a fost completat macar un camp (si doar pentru conturile cu parola).
  const wantsPasswordChange =
    userData?.has_password === true && Boolean(currentPassword || newPassword);

  if (wantsPasswordChange && (!currentPassword || !newPassword)) {
    showMessage('Completează parola curentă și parola nouă.', 'error');
    return;
  }

  try {
    // Salvare nume si prenume
    const usernameResponse = await fetch(`${apiUrl}/user/update-username`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        username
      }),
    });

    const usernameData = await usernameResponse.json();

    if (!usernameResponse.ok) {
      throw new Error(
        usernameData.message || 'Eroare la salvarea numelui.'
      );
    }

    // Salvare username pentru clasament
    const nicknameResponse = await fetch(`${apiUrl}/user/update-nickname`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        nickname
      }),
    });

    const nicknameData = await nicknameResponse.json();

    if (!nicknameResponse.ok) {
      throw new Error(
        nicknameData.message || 'Eroare la salvarea username-ului.'
      );
    }

    setUserData(prev => ({
      ...prev,
      username: usernameData.username,
      nickname: nicknameData.nickname
    }));

    if (wantsPasswordChange) {
      const passwordResponse = await fetch(`${apiUrl}/user/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ currentPassword, newPassword }),
      });

      const passwordData = await passwordResponse.json().catch(() => ({}));

      if (!passwordResponse.ok) {
        throw new Error(
          `Profilul a fost salvat, dar parola nu: ${passwordData.message || 'eroare la schimbarea parolei.'}`
        );
      }

      setCurrentPassword('');
      setNewPassword('');
      showMessage('Profilul și parola au fost salvate!');
      return;
    }

    showMessage('Profilul a fost salvat!');
  } catch (error) {
    console.error(error);
    showMessage(error.message, 'error');
  }
};

  const handleDarkModeToggle = async () => {

	const newMode = !darkMode;

	setDarkMode(newMode);

	try {

	  const response = await fetch(`${apiUrl}/user/theme`, {

		method: 'POST',

		headers: { 'Content-Type': 'application/json' },

		credentials: 'include',

		body: JSON.stringify({ dark_mode: newMode }),

	  });

	  if (!response.ok) throw new Error('Tema nu a putut fi salvata.');

	} catch (error) {

	  console.error(error);

	  setDarkMode(!newMode);

	}

  };

  const handleSoundEffectsToggle = async () => {

	const newValue = !soundEffects;

	setSoundEffects(newValue);

	try {

	  const response = await fetch(`${apiUrl}/user/sound-effects`, {

		method: 'POST',

		headers: { 'Content-Type': 'application/json' },

		credentials: 'include',

		body: JSON.stringify({ sound_effects: newValue }),

	  });

	  if (!response.ok) throw new Error('Preferinta nu a putut fi salvata.');

	} catch (error) {

	  console.error(error);

	  setSoundEffects(!newValue);

	}

  };


const handleResetProgress = async (courseId) => {
  if (![1, 2].includes(courseId)) {
    throw new Error('Curs invalid pentru resetare.');
  }

  const response = await fetch(`${apiUrl}/user/reset-progress`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ courseId })
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      data.message || 'Progresul nu a putut fi resetat.'
    );
  }

  // Verificam ca serverul a procesat cursul solicitat.
  if (Number(data.courseId) !== courseId) {
    throw new Error(
      'Serverul nu a confirmat resetarea cursului selectat.'
    );
  }

  return data;
};


  const handleLogout = async () => {

	try {

	  const response = await fetch(`${apiUrl}/logout`, {

		method: 'POST',

		credentials: 'include',

	  });

	  if (!response.ok) throw new Error('Deconectarea a esuat.');

	  clearCourseStorage();

	  redirectToLogin();

	} catch (error) {

	  console.error('Logout error:', error);

	}

  };



const handleTabClick = key => {
  setActiveTab(key);

  if (isMobile) setShowCardMobile(true);
};

const handleDeleteAccount = async () => {
  setDeletingAccount(true);
  setDeleteError('');

  try {
    const response = await fetch(`${apiUrl}/delete-account`, {
      method: 'DELETE',
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Stergerea contului a esuat.');
    }

    // Succes confirmat de server (2xx): curatam sesiunea locala.
    clearCourseStorage();
    if (setAuthUser) setAuthUser(null);
    navigate('/', { replace: true });
  } catch (error) {
    console.error('Delete account error:', error);
    setDeleteError('Nu am putut sterge contul. Incearca din nou mai tarziu.');
    setDeletingAccount(false);
  }
};

// DESCHIDERE EDITOR AVATAR

const handleOpenAvatarEditor = () => {

  setShowAvatarEditor(true);

  onAvatarEditorChange?.(true);

};

// INCHIDERE EDITOR AVATAR

const handleCloseAvatarEditor = () => {

  setShowAvatarEditor(false);

  onAvatarEditorChange?.(false);

};

// Aceeasi salvare ca in Profil.jsx
const handleSaveAvatar = async (newAvatar) => {
  if (isSavingAvatar) return;
  try {
	setIsSavingAvatar(true);
	const response = await fetch(`${apiUrl}/user/avatar`, {
	  method: 'PUT',
	  credentials: 'include',
	  headers: { 'Content-Type': 'application/json' },
	  body: JSON.stringify({ avatar_config: newAvatar })
	});

	if (!response.ok) {
	  const data = await response.json().catch(() => ({}));
	  throw new Error(data.message || 'Avatarul nu a putut fi salvat.');
	}

	setUserData(current =>
	  current ? { ...current, avatar_config: newAvatar } : current
	);
	window.dispatchEvent(
	  new CustomEvent('avatarUpdated', { detail: newAvatar })
	);
	handleCloseAvatarEditor();
  } catch (error) {
	console.error('Eroare salvare avatar:', error);
	alert(error.message || 'Avatarul nu a putut fi salvat.');
  } finally {
	setIsSavingAvatar(false);
  }
};

useEffect(() => {

  const handleAvatarUpdated = (event) => {

	setUserData(current => {

	  if (!current) return current;

	  return {

		...current,

		avatar_config: event.detail

	  };

	});

  };

  window.addEventListener(

	'avatarUpdated',

	handleAvatarUpdated

  );

  return () => {

	window.removeEventListener(

	  'avatarUpdated',

	  handleAvatarUpdated

	);

  };

}, []);

  const handleBackFromSettings = () => {

	if (typeof onBackToProfile === 'function') {

	  onBackToProfile();

	} else {

	  window.history.back();

	}

  };

  // Un singur renderer pentru desktop si mobil, pentru a evita diferentele.

  const renderActiveContent = () => {

	switch (activeTab) {

	  case 'profil':

		return (

<ProfilCard

  userData={userData}

  onProfilePictureChange={handleFileChange}

  onProfilePictureDelete={onProfilePictureDelete}

  onProfileSave={onProfileSave}

  selectedFile={selectedFile}

  previewImage={previewImage}

  successMessage={successMessage}

  messageType={messageType}

  currentPassword={currentPassword}

  onCurrentPasswordChange={setCurrentPassword}

  newPassword={newPassword}

  onNewPasswordChange={setNewPassword}

  handleFileChange={handleFileChange}

  uploadProfilePicture={uploadProfilePicture}

  username={username}
  nickname={nickname}
onNicknameChange={setNickname}

  onUsernameChange={setUsername}

  onEditAvatar={handleOpenAvatarEditor}

/>

		);

	  case 'preferinte':

		return (

		  <PreferinteCard

			darkMode={darkMode}

			soundEffects={soundEffects}

			handleDarkModeToggle={handleDarkModeToggle}

			handleSoundEffectsToggle={handleSoundEffectsToggle}

		  />

		);

	 

		case 'aplicatie':
  return <PWASettingsCard />;

	  case 'resetare-progres':

		return <ResetareProgres onResetProgress={handleResetProgress} />;

	  case 'plan':

		return (

		  <DetaliiPlanCard />

		);

	 




case 'confidentialitate':
  return (
    <NoticeCard title="Confidentialitate">
      <div className="confidentialitate-actions">
        <Link to="/politica" className="feedback-button">
          Politica de confidentialitate
        </Link>

        <button
          type="button"
          className="delete-account-button"
          onClick={() => setActiveTab('stergere-cont')}
        >
          Sterge contul
        </button>
      </div>
    </NoticeCard>
  );

case 'stergere-cont':
  return (
    <InchidereContCard
      handleDeleteAccount={handleDeleteAccount}
      deleting={deletingAccount}
      error={deleteError}
    />
  );


	case 'feedback':
  return (
    <NoticeCard title="Feedback">
      <a href="/feedback" className="feedback-button">
        Trimite feedback
      </a>
    </NoticeCard>
  );

	  case 'intrebari':

		return (

		  <NoticeCard title="Intrebari">

			<a href="/FAQ" className='button-questions'>
			Vezi intrebari frecvente
			</a>

		  </NoticeCard>

		);

	  default:

		return null;

	}

  };

  if (loading) {

	return (

	  <div className="welcome-screen-lesson">

		<div className="loading-dots">

		  <span />

		  <span />

		  <span />

		</div>

	  </div>

	);

  }

  if (showAvatarEditor) {
	return (
	  <AvatarEditor
		initialAvatar={{
		  ...defaultAvatar,
		  ...(userData?.avatar_config || {})
		}}
		onBack={handleCloseAvatarEditor}
		onSave={handleSaveAvatar}
	  />
	);
  }

  return (

	<div className="componentsmenu-container-main settings-page">

	  <div className="componentsmenu-left-blank" />

	  {!isMobile && (

		<div className="settingsContainer">

		  <div className="tabContent">

			{renderActiveContent()}

		  </div>

		</div>

	  )}

	  {isMobile && (

		<div className="mobileOverlay">

		  {!showCardMobile ? (

			<div className="mobileMenuCard">

			  <div className="mobileMenuHeader">

				<span className="mobBackIcon" onClick={handleBackFromSettings}>

				  <FontAwesomeIcon icon={faChevronLeft} />

				</span>

				<span

				  className="mobileMenuTitle"

				  style={{ flex: 1, textAlign: 'center', fontWeight: 'bold' }}

				>

				  Setari

				</span>

			  </div>

			  <div className="mobileMenuListRows">

				{GROUPS.map(group => (

				  <div key={group.title} className="mobileSettingsGroup">

					<h3 className="mobileSettingsGroupTitle">{group.title}</h3>

					<div className="mobileSettingsGroupCard">

					  {group.tabs.map(tab => (

						<button

						  key={tab.key}

						  type="button"

						  className="mobileSettingsGroupRow"

						  onClick={() => handleTabClick(tab.key)}

						>

						  <span>{tab.label}</span>

						  <span className="mobileMenuArrow">&#8250;</span>

						</button>

					  ))}

					</div>

				  </div>

				))}

				<div className="mobileMenuRowCard">

				  <button

					type="button"

					className="mobileMenuRowInner"

					onClick={handleLogout}

				  >

					<FontAwesomeIcon

					  icon={faRightFromBracket}

					  className="logoutIcon"

					/>

					Deconectare

				  </button>

				</div>

			  </div>

			</div>

		  ) : (

			<div className="mobSectionCard">

			  <div className="mobSectionHeader">

				<span className="mobBackIcon" onClick={() => setShowCardMobile(false)}>

				  <FontAwesomeIcon icon={faChevronLeft} />

				</span>

				<div className="mobSectionTitle">

				  {activeLabel}

				</div>

			  </div>

			  <div className="mobSectionContent">

				<div className="mobSectionInner">

				  {renderActiveContent()}

				</div>

			  </div>

			</div>

		  )}

		</div>

	  )}

	  {!isMobile && (

		<div className="right-elements-componentsmenu-settins">

		  <div className="settingsDesktopMenu">

			{GROUPS.map(group => (

			  <div className="tabMenuCard" key={group.title}>

				<h3 className="tabMenuTitle">{group.title}</h3>

				{group.tabs.map(tab => (

				  <button

					key={tab.key}

					type="button"

					className={activeTab === tab.key ? 'tabActive' : 'tab'}

					onClick={() => handleTabClick(tab.key)}

				  >

					{tab.label}

				  </button>

				))}

			  </div>

			))}

			<div className="logoutCard">

			  <button

				type="button"

				className="logoutButton"

				onClick={handleLogout}

			  >

				<FontAwesomeIcon icon={faRightFromBracket} />

				Deconectare

			  </button>

			</div>

		  </div>

		</div>

	  )}

	  



	</div>

  );

};

export default Settings;
